// src/data/eventsData.js
export const categories = [
  { id: "weddings", label: "Weddings" },
  { id: "parties", label: "Parties" },
  { id: "corporate", label: "Corporate Events" },
];

export const products = {
  weddings: [
    { id: "wedding-planner", name: "Wedding Planner", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: false, appointment: true },
    { id: "wedding-decor", name: "Wedding Decor", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: false },
  ],
  parties: [
    { id: "birthday-party", name: "Birthday Party", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: false },
  ],
  corporate: [
    { id: "team-building", name: "Team Building", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: false },
  ],
};